<template>
  <modal body-class="pr-0 mt-2 pb-0" title="Item Inventory" size="xl" height="500px" no-scroll ref="modal">
    <template #buttons>
      <b-button variant="link" class="text-white" size="sm" v-if="id_filter && loaded" @click="showAll()">SHOW ALL
      </b-button>
      <b-button variant="link" class="text-white" size="sm" v-else-if="id && loaded" @click="id_filter = id">HIDE OTHERS
      </b-button>
      <b-button variant="link" class="text-white d-none d-sm-inline" v-if="wideUrl" size="sm" @click="wideOpen">EXPAND
      </b-button>
    </template>
    <item-inventory :url="url" :highlight="id && [id]" :show-only="id_filter"
                    @loaded="loaded = true" ref="inventory"/>
  </modal>
</template>

<script>
import ItemInventory from './item-inventory'

export default {
  name: "item-inventory-modal",
  props: {
    url: String,
    wideUrl: String,
    id: [String, Number],
  },
  data() {
    return {
      id_filter: this.id,
      loaded: false
    }
  },
  components: {
    ItemInventory
  },
  methods: {
    wideOpen() {
      this.$refs.modal.close()
      this.$router.push(this.wideUrl)
    },
    showAll() {
      this.id_filter = null
    }
  }
}
</script>

<style scoped>

</style>